import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { User } from '../../services/definitions.service';
import { DataModelService } from '../../services/data-model.service';

export interface AddParticipantDialogData {
  eventPath: string;
  existingUserIds: string[];
}

export interface AddParticipantDialogResult {
  confirmed: boolean;
  user?: User;
}

@Component({
  selector: 'app-calendar-event-add-participant-dialog',
  templateUrl: './calendar-event-add-participant-dialog.component.html',
  styleUrls: ['./calendar-event-add-participant-dialog.component.css'],
})
export class CalendarEventAddParticipantDialogComponent implements OnInit {
  allUsers: User[] = [];
  filteredUsers: User[] = [];
  selectedUser: User | null = null;
  isLoading: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<CalendarEventAddParticipantDialogComponent>,
    private dataModel: DataModelService,
    @Inject(MAT_DIALOG_DATA) public data: AddParticipantDialogData
  ) {}

  ngOnInit(): void {
    this.loadUsers();
  }

  /**
   * Loads all users and filters out those already registered.
   */
  async loadUsers(): Promise<void> {
    this.isLoading = true;

    try {
      const users = await this.dataModel.loadAllUsers(false, true);

      if (Array.isArray(users)) {
        this.allUsers = users as User[];
        const existingSet = new Set(this.data.existingUserIds || []);
        this.filteredUsers = this.allUsers
          .filter((user) => !existingSet.has(user.uid))
          .sort((a, b) => {
            const nameA = this.getUserDisplayName(a).toLowerCase();
            const nameB = this.getUserDisplayName(b).toLowerCase();
            return nameA.localeCompare(nameB);
          });
      }
    } catch {
      this.filteredUsers = [];
    }

    this.isLoading = false;
  }

  /**
   * Returns a display name for a user.
   */
  getUserDisplayName(user: User): string {
    if (!user) {
      return 'Unbekannt';
    }

    const first = user.personalData?.firstName || '';
    const last = user.personalData?.lastName || '';
    const full = `${first} ${last}`.trim();
    return full || user.displayName || user.email || 'Unbekannt';
  }

  onConfirm(): void {
    if (!this.selectedUser) {
      return;
    }

    this.dialogRef.close({
      confirmed: true,
      user: this.selectedUser,
    } as AddParticipantDialogResult);
  }

  onCancel(): void {
    this.dialogRef.close({ confirmed: false } as AddParticipantDialogResult);
  }
}
